class Accordion {
  constructor() {
    this._cacheSelectors();
    this._init();
  }

  _cacheSelectors() {
    this._triggers = document.querySelectorAll('.js-button-accordion');
  }

  _init() {
    this._triggers.forEach((trigger) => {
      trigger.addEventListener('click', (e) => {
        const _this = e.currentTarget;

        const panelGroup = _this.parentElement;

        this.panel = _this.nextElementSibling;

        if (this.panel.classList.contains('is-active')) {
          panelGroup.classList.remove('is-active');
          this.panel.classList.remove('is-active');
        } else {
          panelGroup.classList.add('is-active');
          this.panel.classList.add('is-active');
        }
      });
    });
  }
}

export default Accordion;
